import { render, staticRenderFns } from "./Galerija.vue?vue&type=template&id=6e9f62be&scoped=true"
import script from "./Galerija.vue?vue&type=script&lang=js"
export * from "./Galerija.vue?vue&type=script&lang=js"
import style0 from "./Galerija.vue?vue&type=style&index=0&id=6e9f62be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f62be",
  null
  
)

export default component.exports